import React, { useEffect, useState } from "react";
import styles from "./Requests.module.css";
import { useTranslation } from "react-i18next";
import Person from "../../Assests/Images/Person.svg";
import { capitalizeFirstLetter, formatDate } from "../../Utils/CommonFunction";
import {
  CustomButton,
  CustomImgButton,
} from "../../ReactBootstrap/CustomTabButton";
import Cross from "../../Assests/Images/Cross.svg";
import CheckBoxImg from "../../Assests/Images/successIcon.png";
import RequestReject from "./RequestReject";
import RequestAccept from "./RequestAccept";
import { userLogoutClear } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import TrainzaApi from "../../Helpers/Api";
import Toster from "../../Common/Toster/Toster";
import { STATUS_CODE } from "../../Utils/StatusCode";
import { STATUS_MSG } from "../../Utils/StatusMsg";

import { useSelector } from "react-redux";
import Loader from "../../Common/Loader/Loader";
import { CONSTANT } from "../../Utils/Constant";
import LimitReached from "./LimitReached";

export default function Requests({
  memberLimit,
  totalMemberAdded,
  setTotalMemberAdded,
  setShowtab,
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isAuthenticated = useSelector(
    (state) => state.user.userTokenTrainzaBrand
  );

  const [isLoading, setIsLoading] = useState(true);

  const [requestList, setRequestList] = useState([]);

  const [modelData, setModelData] = useState({ show: false, id: "" });

  const [pageNumber, setPageNumber] = useState(1);
  const [isLoadMore, setIsLoadMore] = useState(false);
  const [totalCount, setTotalCount] = useState();

  const [grpList, setGrpList] = useState([]);

  const [showLimitModal, setShowLimitModal] = useState(false);

  const handleRequestList = (page) => {
    setIsLoading(true);
    const response = TrainzaApi.getRequestList(isAuthenticated, page);
    setIsLoading(true);
    response.then((response) => {
      setIsLoading(false);
      if (
        response?.data?.code === STATUS_CODE.INVALID_TOKEN ||
        response?.data?.code === STATUS_CODE.SESSION_EXPIRED
      ) {
        dispatch(userLogoutClear());
        Toster(t("SESSION_EXPIRED"), "error");
        navigate("/sign-up");
      } else {
        if (page == 1) {
          setRequestList(response?.data?.memberList);
        } else {
          setRequestList([...requestList, ...response?.data?.memberList]);
        }
        setPageNumber(page + 1);
        setIsLoadMore(response?.data?.loadMore);
        setTotalCount(response?.data?.count);
      }
    });
  };

  useEffect(() => {
    handleRequestList(1);
  }, []);

  const handleAcceptOrDeclineRequests = (action) => {
    // if (action === 1 && totalMemberAdded >= memberLimit) {
    //   setModelData({ show: false, id: "" });
    //   setShowLimitModal(true);
    //   return;
    // }

    setIsLoading(true);

    const group = grpList
      ?.filter((item) => item?.isChecked)
      ?.map((item) => item?.id);

    const PostData = new FormData();

    PostData.append("actionType", action);
    if (action === 1) {
      PostData.append("trainingGroups", group);
    }

    TrainzaApi.AcceptOrRejectReq(
      isAuthenticated,
      PostData,
      modelData?.data?.id
    ).then((response) => {
      setIsLoading(false);
      const ResponseCode = STATUS_MSG[response?.data?.code];
      if (
        response?.data?.code === STATUS_CODE.INVALID_TOKEN ||
        response?.data?.code === STATUS_CODE.SESSION_EXPIRED
      ) {
        dispatch(userLogoutClear());
        Toster(t("SESSION_EXPIRED"), "error");
      } else {
        setModelData({ show: false, id: "" });

        if (response?.code === STATUS_CODE.SUCCESS) {
          handleRequestList(1);
          if (action === 1) {
            Toster(t("REQ_ACCEPTED"), "success");
            setTotalMemberAdded(totalMemberAdded + 1);
          } else {
            Toster(t("REQ_REJECTED"), "success");
          }

          setIsLoading(false);
        } else if (response?.data?.code === STATUS_CODE.VALIDATION_ERROR) {
          Toster(response?.data?.message, "error");
        } else {
          Toster(t(ResponseCode), "error");
        }
      }
    });
  };

  return (
    <div>
      {isLoading && <Loader />}

      <div className={styles.summary}>
        <div className={styles.personalDetail}>
          <p>{t("PENDING_MEMBERS_REQUESTS")}</p>
        </div>
        <h1 className={styles.memberLimit}>
          {t("MEMBER_LIMIT")} - {totalMemberAdded}/
          {memberLimit ? memberLimit : 0}
        </h1>
      </div>
      <div className={styles.devider}></div>

      {requestList?.map((info, index) => {
        return (
          <div className={styles.detail} key={index}>
            <div className={styles.info} key={index}>
              <img
                src={info?.profilePicture ? info?.profilePicture : Person}
                alt="Person"
              ></img>
              <div className={styles?.infoOfMember}>
                <p className={styles?.name}>
                  {capitalizeFirstLetter(
                    info?.firstName ? info?.firstName : ""
                  )}{" "}
                  {info?.lastName ? info?.lastName : ""}
                </p>
                <p className={styles.gender}>
                  {info.gender === 1
                    ? t("MALE")
                    : info?.gender === 2
                    ? t("FEMALE")
                    : t("N/A")}{" "}
                  - {info?.age ? info?.age : 0}
                </p>
                <p className={styles.date}>{formatDate(info?.requestDate)}</p>
              </div>
            </div>
            <div className={styles.editCross}>
              <CustomImgButton
                variant="primary"
                onClick={() => {
                  setModelData({ show: true, data: info, isReject: true });
                }}
                src={Cross}
                alt="cross"
              ></CustomImgButton>
              <CustomImgButton
                variant="primary"
                onClick={() => {
                  if (totalMemberAdded >= memberLimit) {
                    setModelData({ show: false, id: "" });
                    setShowLimitModal(true);
                  } else {
                    setModelData({ show: true, data: info, isReject: false });
                  }
                }}
                src={CheckBoxImg}
                alt="edit"
              ></CustomImgButton>
            </div>
          </div>
        );
      })}

      {!requestList?.length && (
        <>
          <span className={styles.noRequests}>{t("CURRENT_NO_REQUESTS")} </span>
          -
          <span
            className={styles.noRequestMember}
            onClick={() => setShowtab(2)}
          >
            {" "}
            {t("INVITE_MEMBER")}
          </span>
        </>
      )}

      <div className={styles.inviteormore}>
        <div className={styles.membersCount}>
          <CustomButton
            variant="footerBtnCustom"
            onClick={() => {
              setShowtab(2);
            }}
          >
            <p>
              {t("Invite")}
              <span> {t("Member")}</span>
            </p>
          </CustomButton>

          <p>
            {totalCount}{" "}
            <span>{totalCount > 1 ? t("Requests") : t("Request")}</span>
          </p>
          <CustomButton
            variant="footerBtnCustom"
            opacity={isLoadMore ? "1" : CONSTANT.OPACITY_RATIO}
            onClick={() => {
              if (isLoadMore) {
                handleRequestList(pageNumber);
              }
            }}
          >
            <p>
              {t("LOAD")} <span>{t("MORE")}</span>
            </p>
          </CustomButton>
        </div>
      </div>

      {modelData?.isReject && (
        <RequestReject
          modelData={modelData}
          setModelData={setModelData}
          handleRejectConfirm={() => {
            handleAcceptOrDeclineRequests(2);
          }}
        />
      )}

      {!modelData?.isReject && (
        <RequestAccept
          modelData={modelData}
          setModelData={setModelData}
          handleAcceptRequests={() => {
            handleAcceptOrDeclineRequests(1);
          }}
          grpList={grpList}
          setGrpList={setGrpList}
        />
      )}

      <LimitReached
        show={showLimitModal}
        handleClose={() => {
          setShowLimitModal(false);
        }}
      />
    </div>
  );
}
